import { TooltipPlugin } from 'bootstrap-vue'
import Vue from 'vue'
Vue.use(TooltipPlugin)
